<ng-container *transloco="let t" class="container">
    <app-admin-modal-layout
            [title]="title ?? ''"
            [saveLabel]="confirmButtonTitle ?? t('app.common.confirm')"
            (onSave)="onConfirmClick()"
            (onClose)="onDismissClick()"
            [saveDisabled]="!saveEnabled"
    >
        <div class="border-shadow p-3">
            <app-competitor-info [isTeam]="forTeamMembers" [competitor]="competitor"/>
        </div>

        <div class="border-shadow mt-3">
            <table class="table w-100">
                <thead>
                <tr>
                    <th>{{ t('organiser.event.details.control.point.type') }}</th>
                    <th>{{ t('measurements.time') }}</th>
                    <th>{{ t('measurements.chipTime') }}</th>
                    <th scope="col" class="more-column-width"></th>
                </tr>
                </thead>
                <tbody>
                @for (section of sections; track section.member?.id ?? 'solo') {
                @if (forTeamMembers) {
                <tr class="member-row" (click)="toggleSection(section)">
                    <td colspan="3">
                        <div>
                            <div class="detail-col-title mb-0">
                                {{ ((section.member?.firstName ?? '' ) | uppercase) + " " + ((section.member?.lastName ?? '' ) | uppercase) }}
                            </div>
                            <div class="d-flex gap-2 justify-content-start">
                                <div>{{t('app.common.chipNumber')}}: {{ section.member?.chipNumber ?? '-' }}</div>
                                <div>|</div>
                                <div>{{t('competitor.table.startNumberExtension')}}: {{ section.member?.startNumberExtension ?? '-' }}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex w-100 justify-content-center align-items-center">
                            <i class="bi color-grey-neutral-400" [ngClass]="section.expanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </div>
                    </td>
                </tr>
                }

                @if (section.expanded) {
                @for (controlTime of section.controlTimes; track controlTime; let idx = $index) {
                <tr [class.active]="controlTime.selected"
                    [class.disabled]="((controlTime.controlWaypoint?.waypointTypeId !== WaypointType.START_WAYPOINT) && section.disableAll) || (controlTime.controlWaypoint?.waypointTypeId === WaypointType.START_WAYPOINT && forTeamMembers)"
                    (click)="onItemSelect(section, controlTime)">
                  <td class="center-align py-6">
                    @if (controlTime.controlWaypoint?.waypointTypeId === WaypointType.CONTROL_WAYPOINT) {
                {{
                t("organiser.event.details.control.point.waypointType." +
                    controlTime.controlWaypoint?.waypointTypeId)
                }}
                <app-language-output [hrLabel]="controlTime.controlWaypoint?.pointNameHr" [enLabel]="controlTime.controlWaypoint?.pointNameEn" [srLabel]="controlTime.controlWaypoint?.pointNameSr"
                                     [itLabel]="controlTime.controlWaypoint?.pointNameIt" [siLabel]="controlTime.controlWaypoint?.pointNameSlo" [bsLabel]="controlTime.controlWaypoint?.pointNameBs" [languages]="languages"/>

                } @else if (!controlTime.controlWaypoint && (controlTime?.lap ?? 0) > 0) {
                {{ t('measurements.lap.label', {lap: controlTime.lap}) }}
                } @else {
                {{
                t("organiser.event.details.control.point.waypointType."
                    + controlTime.controlWaypoint?.waypointTypeId)
                }}
                }
                </td>
                <td class="center-align py-6">
                {{
                (controlTime?.time) ? (controlTime?.time | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-'
                }}
                </td>
                <td class="center-align py-6">
                {{
                (controlTime?.chipTime) ? (controlTime?.chipTime |
                    localizedDate:'dd.MM.yyyy HH:mm:ss.SSS')
                  : '-'
                }}
                </td>
                <td class="center-align py-6">
                  <div class="d-flex justify-content-center align-items-center">
                    <input type="checkbox" class="form-check-input border-2"
                           [disabled]="(controlTime.controlWaypoint?.waypointTypeId !== WaypointType.START_WAYPOINT) && section.disableAll"
                           [checked]="controlTime.selected"
                           (click)="$event.stopPropagation()"
                           (change)="onItemSelect(section, controlTime)"/>
                  </div>
                </td>
              </tr>
                }
                }
                }
                </tbody>
            </table>
        </div>
    </app-admin-modal-layout>
</ng-container>